export default {
    storageDeviceTypesActiveByCompany: [],
    storageDeviceTypesByCompanyAccess: [],
    storagesTypesByCompany: [],
    allStoragesTypes: [],
    loading: true
}
